import fp from 'lodash/fp';

export const mapActionsFromConfigurations = (moduleName) => (configurations) => {
  return {
    [moduleName]: {
      api: {
        ...fp.reduce(
          (prev, { name, action }) => ({
            ...prev,
            [name]: fp.get(`${moduleName}.api.${name}`)(action)
          }),
          {}
        )(configurations)
      },
      ...fp.reduce(
        (prev, { name, action }) => ({
          ...prev,
          [name]: action[moduleName][name]
        }),
        {}
      )(configurations)
    }
  }
} 


// WEBPACK FOOTER //
// ./src/state/helpers/action.js